/**
 * Careers Page Scripts
 *
 * Loaded on careers page templates via functions.php
 *
 * @package Interact_26
 */

import './styles/index.scss';

import { initCareers } from './scripts/careers';
import { initCarousel } from './scripts/carousel';
import { initLocationTabs } from './scripts/location-tabs';
import { initTeamJobCounts } from './scripts/team-job-counts';

const onDocumentReady = (callback: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

onDocumentReady(() => {
  initCareers();
  initCarousel();
  initLocationTabs();
  initTeamJobCounts();
});
